module.exports = __webpack_public_path__ + "static/media/logo.0f22ea3d.png";


//////////////////
// WEBPACK FOOTER
// ./src/style/imgs/logo.png
// module id = 2308
// module chunks = 0